<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1140"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1144"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1154"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1152" /></clipPath></defs><g
     id="g1146"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1148"><g
         id="g1150"
         clip-path="url(#clipPath1154)"><g
           id="g1156"
           transform="translate(502,147)"><path
             d="m 0,0 c 0,-53.572 -43.428,-97 -97,-97 -53.572,0 -97,43.428 -97,97 0,53.572 43.428,97 97,97 C -43.428,97 0,53.572 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1158" /></g><g
           id="g1160"
           transform="translate(381.8313,125.9732)"><path
             d="m 0,0 c 0,-11.613 10.373,-21.027 23.169,-21.027 12.795,0 23.168,9.414 23.168,21.027 0,11.613 -10.373,21.027 -23.168,21.027"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1162" /></g><g
           id="g1164"
           transform="translate(405,147)"><path
             d="m 0,0 c -12.796,0 -23.169,9.414 -23.169,21.027 0,11.613 10.373,21.027 23.169,21.027 12.796,0 23.169,-9.414 23.169,-21.027"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1166" /></g><g
           id="g1168"
           transform="translate(405,199)"><path
             d="M 0,0 V -9.946"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1170" /></g><g
           id="g1172"
           transform="translate(405,95)"><path
             d="M 0,0 V 9.946"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1174" /></g><g
           id="g1176"
           transform="translate(185,354)"><path
             d="M 0,0 H -175"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1178" /></g><g
           id="g1180"
           transform="translate(448,354)"><path
             d="M 0,0 H -173"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1182" /></g><g
           id="g1184"
           transform="translate(64,462)"><path
             d="M 0,0 V -56"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1186" /></g><g
           id="g1188"
           transform="translate(284,462)"><path
             d="M 0,0 V -56"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1190" /></g><g
           id="g1192"
           transform="translate(174,462)"><path
             d="M 0,0 V -56"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1194" /></g><g
           id="g1196"
           transform="translate(394,462)"><path
             d="M 0,0 V -56"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1198" /></g><path
           d="M 130,242 H 74 v 56 h 56 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path1200" /><path
           d="m 258,242 h -56 v 56 h 56 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path1202" /><path
           d="m 386,242 h -56 v 56 h 56 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path1204" /><path
           d="M 130,130 H 74 v 56 h 56 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path1206" /><path
           d="m 258,130 h -56 v 56 h 56 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path1208" /><g
           id="g1210"
           transform="translate(346.012,70)"><path
             d="m 0,0 h -296.012 c -22.091,0 -40,17.909 -40,40 v 284 c 0,22.091 17.909,40 40,40 h 360 c 22.091,0 40,-17.909 40,-40 V 162.945"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1212" /></g><g
           id="g1214"
           transform="translate(230,354)"><path
             d="M 0,0 V 0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1216" /></g></g></g></g></svg>
</template>
